import { LoadingSpinner } from "@uhg-abyss/web/ui/LoadingSpinner";

export type LoadingSpinnerModalProps = {
  isLoading: boolean;
};

export function LoadingSpinnerModal({
  isLoading
}) {
  return (
    <div
      style={{
        zIndex: 999,
        backgroundColor: '#FFFFFF',
        opacity: 0.75,
        position: 'fixed',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        margin: 0,
        top: 0,
        left: 0,
      }}
    >
      <LoadingSpinner
        size="xl"
        isLoading={isLoading}
        ariaLoadingLabel="Loading page content"
      />
    </div>
  );
}

